// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3aTly","text":"SelectPayment_text__FML7W","title":"SelectPayment_title__EQXQ-","btn":"SelectPayment_btn__5c7st"};